module.exports = __webpack_public_path__ + "static/media/app-store.85439dad.png";